<template>
  <div
    class="notification"
    :class="'notification--' + type"
    v-if="showNotification"
  >
    <div class="notification__dismiss" v-if="allowDismiss" @click="onDismiss">
      <fa icon="times" />
    </div>
    <div class="notification__icon">
      <fa icon="check-circle" v-if="type === 'success'" />
      <fa icon="info-circle" v-if="type === 'info'" />
      <fa icon="exclamation-triangle" v-if="type === 'warning'" />
      <fa icon="exclamation-circle" v-if="type === 'error'" />
    </div>
    <div class="notification__content">
      <div class="notification__title">{{ title }}</div>
      <div class="notification__body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    title: String,
    allowDismiss: Boolean
  },
  data() {
    return {
      showNotification: true
    };
  },
  methods: {
    onDismiss() {
      this.showNotification = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  border: 3px solid;
  padding: 20px;
  margin-bottom: 15px;
  position: relative;
  margin: 10px 0;

  &__dismiss {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }

  &__icon {
    margin-right: 10px;
  }

  &__title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  &__body {
    p {
      margin-bottom: 5px;
    }
  }

  &--success {
    border-color: #208836;
    .notification__icon {
      color: #208836;
    }
  }

  &--info {
    border-color: #8a4e94;
    .notification__icon {
      color: #8a4e94;
    }
  }

  &--warning {
    border-color: #ffc107;
    .notification__icon {
      color: #ffc107;
    }
  }

  &--error {
    border-color: #b00020;
    .notification__icon {
      color: #b00020;
    }
  }
}
</style>
